import { orderingUrl } from "../resources";
import postRequest from '../common/postRequest';

async function createOrderByPhoneService(data, token) {

    let url = `${orderingUrl}/CreateOrderByPhoneServiceByRestaurant`;

    return await postRequest.postDataWithToken(url, data, token);

}

export default {
    createOrderByPhoneService
}

